export const PersonnelTypes = {
    PARTNER: 'Ehepartner',
    SIBLING: 'Geschwister',
    OTHER: 'Sonstige',
    PARENT: 'Eltern',
    CHILD: 'Kind',
};
